// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 152 ? "about" : chunkId) + "." + {"152":"a136ab76","831":"76ac8b2d"}[chunkId] + ".js";
};